import React, { Component } from 'react';
import { Dimmer, Loader, Segment } from 'semantic-ui-react'
import ReactHighcharts from 'react-highcharts';
import {Tabs} from './Tabs';
import {PlainValue} from './analytics/PlainValue';
import {OperatingSystem} from './analytics/OperatingSystem';
import {DataDownloadVsUpload} from './analytics/DataDownloadVsUpload';
import {Devices} from './analytics/Devices';
import {NewVsReturningUsers} from './analytics/NewVsReturningUsers';
import {TotalVisits} from './analytics/TotalVisits';

class Analytics extends Component {
    constructor(props) {
        super(props);

        this.clearAnalyticsValues = this.clearAnalyticsValues.bind(this);
        this.updateAnalyticsValues = this.updateAnalyticsValues.bind(this);
        this.showLoader = this.showLoader.bind(this);
        this.hideLoader = this.hideLoader.bind(this);
        this.buildChart = this.buildChart.bind(this);

        this.clearAnalyticsValues();
    }

    clearAnalyticsValues() {
        this.state = {
            totalSubscribers: undefined,
            totalNewSubscribers: undefined,
            returningSubscribers: undefined,
            operatingSystemData: undefined,
            downloadAndUploadTimeSeries: {download: undefined, upload: undefined},
            newAndReturningSubscribersTimeSeries: {new: undefined, returning: undefined},
            sessionsTimeSeries: undefined,
            deviceFormats: [],
            selectedPeriod: undefined
        };
    }

    updateAnalyticsValues(state) {
        this.setState(state);
    }

    showLoader() {
        this.setState({loaderActive: true});
    }

    hideLoader() {
        this.setState({loaderActive: false});
    }

    buildChart(chart) {
        if (this.props.lang == "nl") {
            ReactHighcharts.Highcharts.setOptions({
                global: {useUTC: false},
                lang: {
                    loading: 'Chargement...',
                    months: ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'],
                    weekdays: ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'],
                    shortMonths: ['jan', 'fév', 'mar', 'avr', 'mai', 'juin', 'juil', 'aoû', 'sep', 'oct', 'nov', 'déc'],
                    exportButtonTitle: "Exporter",
                    printButtonTitle: "Imprimer",
                    rangeSelectorFrom: "Du",
                    rangeSelectorTo: "au",
                    rangeSelectorZoom: "Période",
                    downloadPNG: 'Télécharger en PNG',
                    downloadJPEG: 'Télécharger en JPEG',
                    downloadPDF: 'Télécharger en PDF',
                    downloadSVG: 'Télécharger en SVG',
                    resetZoom: "Réinitialiser le zoom",
                    resetZoomTitle: "Réinitialiser le zoom",
                    thousandsSep: " ",
                    decimalPoint: ','
                }
            });
        } else if (this.props.lang == "fr") {
            ReactHighcharts.Highcharts.setOptions({
                    global: {useUTC: false},
                    lang: {
                        loading: 'Wordt geladen...',
                        months: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'],
                        weekdays: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'],
                        shortMonths: ['jan', 'feb', 'maa', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
                        exportButtonTitle: "Exporteren",
                        printButtonTitle: "Printen",
                        rangeSelectorFrom: "Vanaf",
                        rangeSelectorTo: "Tot",
                        rangeSelectorZoom: "Periode",
                        downloadPNG: 'Download als PNG',
                        downloadJPEG: 'Download als JPEG',
                        downloadPDF: 'Download als PDF',
                        downloadSVG: 'Download als SVG',
                        resetZoom: 'Reset',
                        resetZoomTitle: 'Reset',
                        thousandsSep: '.',
                        decimalPoint: ','
                    }
                }
            );
        } else {
            ReactHighcharts.Highcharts.setOptions({
                global: {useUTC: false},
                lang: {
                    loading: "Loading...",
                    months: [ "January" , "February" , "March" , "April" , "May" , "June" , "July" , "August" , "September" , "October" , "November" , "December"],
                    weekdays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
                    shortMonths: ["Jan" , "Feb" , "Mar" , "Apr" , "May" , "Jun" , "Jul" , "Aug" , "Sep" , "Oct" , "Nov" , "Dec"],
                    exportButtonTitle: "Export",
                    printButtonTitle: "Print",
                    rangeSelectorFrom: "From",
                    rangeSelectorTo: "To",
                    rangeSelectorZoom: "Period",
                    downloadPNG: 'Download PNG image',
                    downloadJPEG: 'Download JPEG image',
                    downloadPDF: 'Download PDF document',
                    downloadSVG: 'Download SVG vector image',
                    resetZoom: "Reset zoom",
                    resetZoomTitle: "Reset zoom level 1:1",
                    thousandsSep: " ",
                    decimalPoint: '.'
                }
            });
        }
        chart.highcharts().render();
    }

    render() {
        const { loaderActive } = this.state;
        var periodMessage = "";
        if (this.state.timePeriod === "last-24-hours") {
            periodMessage = this.props.showMessage('message_2_05');
        } else if (this.state.timePeriod === "last-week") {
            periodMessage = this.props.showMessage('message_2_06');
        } else if (this.state.timePeriod === "last-month") {
            periodMessage = this.props.showMessage('message_2_07');
        }
        var token = this.props.accessToken;
        if (token == null) {
            token = sessionStorage.getItem('token');
        }
        return (
            <div>
                <Tabs updateAnalyticsValues={this.updateAnalyticsValues}
                      clearAnalyticsValues={this.clearAnalyticsValues}
                      accessToken={token}
                      showLoader={this.showLoader}
                      hideLoader={this.hideLoader}
                      changeLang={this.props.changeLang}
                      lang={this.props.lang}
                      showMessage={this.props.showMessage}
                      showFAQ={this.props.showFAQ}
                      showLogin={this.props.showLogin}
                      vRadiusServerId={this.props.vRadiusServerId}/>
                <div id="analyticsContent">
                    <Dimmer.Dimmable as={Segment} dimmed={loaderActive}>
                        <Dimmer active={loaderActive} inverted>
                            <Loader>{this.props.showMessage('message_2_13')}</Loader>
                        </Dimmer>
                        <h5>{this.props.showMessage('message_2_01')}</h5>
                        <div id="analyticsOverview">
                            <h3 className="purple">{this.props.showMessage('message_2_01')}</h3>
                            <div className="overviewData">
                                <i className="icon-person icon"></i>
                                <div>
                                    {this.props.showMessage('message_2_02')}<br/>
                                    <PlainValue className="purple analyticsTitle"
                                                value={this.state.totalSubscribers}/><br/>
                                    {periodMessage}
                                </div>
                            </div>
                            <div className="overviewData">
                                <i className="icon-person icon"></i>
                                <div>
                                    {this.props.showMessage('message_2_03')}<br/>
                                    <PlainValue className="lightBlue analyticsTitle"
                                                value={this.state.totalNewSubscribers}/><br/>
                                    {periodMessage}
                                </div>
                            </div>
                            <div className="overviewData">
                                <i className="icon-person icon"></i>
                                <div>
                                    {this.props.showMessage('message_2_04')}<br/>
                                    <PlainValue className="blue analyticsTitle"
                                                value={this.state.returningSubscribers}/><br/>
                                    {periodMessage}
                                </div>
                            </div>
                        </div>
                        <div className="chartsRow">
                            <div className="chartContainer">
                                <h2 className="purple">{this.props.showMessage('message_2_12')}</h2>
                                <TotalVisits
                                    timePeriod={this.state.timePeriod}
                                    lang={this.props.lang}
                                    data={this.state.sessionsTimeSeries}
                                    showMessage={this.props.showMessage}/>
                            </div>
                            <div className="chartContainer">
                                <h2 className="purple">{this.props.showMessage('message_2_11')}</h2>
                                <NewVsReturningUsers
                                    timePeriod={this.state.timePeriod}
                                    lang={this.props.lang}
                                    data={this.state.newAndReturningSubscribersTimeSeries}
                                    showMessage={this.props.showMessage}/>
                            </div>
                            <div className="chartContainer">
                                <h2 className="purple">{this.props.showMessage('message_2_09')}</h2>
                                <DataDownloadVsUpload
                                    timePeriod={this.state.timePeriod}
                                    lang={this.props.lang}
                                    data={this.state.downloadAndUploadTimeSeries}
                                    buildChart={this.buildChart}
                                    showMessage={this.props.showMessage}/>
                            </div>
                            <div className="chartContainer">
                                <h2 className="purple">{this.props.showMessage('message_2_08')}</h2>
                                <OperatingSystem data={this.state.operatingSystemData}
                                                 showMessage={this.props.showMessage}/>
                            </div>
                            <div className="chartContainer">
                                <h2 className="purple">{this.props.showMessage('message_2_10')}</h2>
                                <Devices data={this.state.deviceFormats}
                                         showMessage={this.props.showMessage}/>
                            </div>
                        </div>

                    </Dimmer.Dimmable>
                </div>
            </div>
        )
    };
};

export default Analytics;



// WEBPACK FOOTER //
// ./src/components/Analytics.jsx